import * as yup from 'common/yup';
import {CommonReportParams} from 'types/diplomat/reports/CommonReportParams';
import {ReportFormatChooserType} from './ReportFormatChooserType';

export const SFTPActivityReportParameters = yup
   .object({
      byUserId: yup.boolean(),
      byUserIp: yup.boolean(),
      userId: yup.string(),
      userIp: yup.string(),
   })
   .concat(CommonReportParams);
export type ISFTPActivityReportParameters = yup.InferType<typeof SFTPActivityReportParameters>;
